import {SymptomActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const SymptomRequestInit = () => {
    return {
        type:SymptomActionType.Symptom_INIT
    }
}

export const SymptomSuccess = (
    objeckt: any
) => {
    return {
        type: SymptomActionType.Symptom_INIT,
        objeckt: objeckt
    }
}

export const getSymptom = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            SymptomSuccess(
                objeckt
            )
        )
    }
}
